/**
 * Experiment setting enabling domain stripping for web retailer and web brand absolute links
 * Product Area: INFRA
 */
export const ABSOLUTE_LINK_DOMAIN_STRIPPING_240201 = 'ABSOLUTE_LINK_DOMAIN_STRIPPING_240201';
